module.exports = __webpack_public_path__ + "static/image/history/pc/202106.jpg?60fcccae";